import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { logout } from './authSlice';
import { reportClientError } from '../utils/errorLogger';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '';
console.log('API Base URL:', apiBaseUrl);
console.log('Environment variables:', import.meta.env);

const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState()?.auth?.userInfo?.token;

    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  const url = typeof args === 'string' ? args : args.url;
  const hasLocalUser = !!api.getState().auth.userInfo;

  console.log('API call to:', url);
  console.log('Current auth state:', hasLocalUser ? 'User logged in' : 'No user');

  const result = await baseQuery(args, api, extraOptions);

  console.log('API response status:', result?.error?.status || (result?.data ? 'Success' : 'Unknown'));

  if (result?.error?.status === 401) {
    const isLoginAttempt = url?.includes('/api/users/auth');
    const isRegisterAttempt = url === '/api/users' || url?.endsWith('/api/users');

    if (hasLocalUser && !isLoginAttempt && !isRegisterAttempt) {
      console.log('Logging out user due to protected endpoint 401');
      api.dispatch(logout());
    }
  }

  const status = result?.error?.status;
  if (status === 'FETCH_ERROR' || status === 'PARSING_ERROR' || (typeof status === 'number' && status >= 500)) {
    reportClientError({
      level: 'error',
      message: `API request failed for ${url}`,
      name: 'ApiRequestError',
      statusCode: typeof status === 'number' ? status : undefined,
      path: url,
      route: window.location.pathname,
      errorDetails: result.error,
      metadata: {
        kind: 'rtk-query',
      },
    });
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: ['User', 'Team', 'League', 'Athlete', 'Athletes', 'Event', 'ErrorLogs', 'News', 'NewsAdmin', 'Billing'],
  endpoints: () => ({}),
});
